import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 6,
			fill: "#AA151B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 24,
			height: 12,
			fill: "#F1BF00"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 18,
			width: 24,
			height: 6,
			fill: "#AA151B"
		})
	]
});
export default SvgEs;
